"use client"

import type React from "react"
import { useState } from "react"
import { connect } from "react-redux"
import type { RootState } from "../../redux/reducers"
import { Navigate } from "react-router-dom"
import { Button, Spinner } from "react-bootstrap"
import ssmso_logo from "../../assets/img/SSMSO-LOGO.png"
import { ChevronDown } from "lucide-react"
// import { Dash, Key, ShieldLock } from "react-bootstrap-icons"
import { parametrosUrlActions } from "../../redux/actions/auth/parametrosUrlActions"

interface Props {
  isAuthenticated: boolean | null
  isDarkMode: boolean
  // parametrosUrlActions: () => Promise<boolean>
}

const ClaveUnica: React.FC<Props> = ({ isAuthenticated, /*parametrosUrlActions */ }) => {
  const [loading, setLoading] = useState(false)

  const [expandedFaq, setExpandedFaq] = useState<number | null>(null)
  // const navigate = useNavigate(); // Hook para redirigir
  const handleClaveUnica = () => {
    setLoading(true)
    const redirectUrl = import.meta.env.VITE_CSRF_CLAVE_UNICA
    window.location.href = redirectUrl
    setLoading(false)
  }

  // const handleDobleFactor = async () => {
  //   setLoading(true)
  //   const resultado = await parametrosUrlActions();

  //   if (resultado) {
  //     setLoading(false)
  //   }
  //   setLoading(false)
  // }

  const toggleFaq = (index: number) => {
    setExpandedFaq(expandedFaq === index ? null : index)
  }
  const faqItems = [
    {
      question: "¿Cómo obtengo mi usuario?",
      answer:
        "Puede ingresar al Sistema de Inventario utilizando su Clave Única. Si el acceso es denegado, contacte al Departamento de Informática al anexo 2505 o escriba a desarrollo@ssmso.cl para solicitar la habilitación de su cuenta.",
    },
    {
      question: "¿Cómo accedo al sistema?",
      answer:
        "El Sistema de Inventario es una aplicación web que no requiere instalación. Solo necesita acceder mediante la URL correspondiente y contar con su Clave Única habilitada para el módulo de activos fijos, otorgada por el Área de Desarrollo."
    },
    {
      question: "¿Cómo obtengo o cambio mi contraseña?",
      answer:
        "Si necesita una contraseña inicial o desea restablecerla, comuníquese con el Departamento de Informática al anexo 2505 o escriba a desarrollo@ssmso.cl.",
    },
    {
      question: "¿Con quién me contacto si tengo problemas con el sistema?",
      answer:
        "En caso de inconvenientes, puede comunicarse con la Unidad de Desarrollo del Departamento de Informática al anexo 262505 o vía correo electrónico a desarrollo@ssmso.cl. Horario de atención: lunes a viernes de 08:30 a 17:30 hrs.",
    },
  ];
  // const handlePrueba = () => {
  //   navigate("/Login");
  // };

  if (isAuthenticated) {
    return <Navigate to="/Inicio" />
  }

  const hoy = new Date();
  const anio = hoy.getFullYear();
  return (
    <div className="min-vh-100 d-flex flex-column flex-md-row">
      {/* Left Section - Login Form */}
      <div className="col-12 col-md-6 d-flex align-items-center justify-content-center p-4">
        <div className="bg-white rounded-4 shadow-sm p-4 w-100" style={{ maxWidth: 400 }}>
          <div className="text-center mb-4">
            <img src={ssmso_logo || "/placeholder.svg"} alt="SSMSO Logo" width={120} className="img-fluid" />
          </div>


          <div className="d-flex flex-column gap-4">

            {/* Acceso con ClaveÚnica */}
            <div className="text-center">
              {/* <h6 className="fw-semibold mb-2">
                Accede con ClaveÚnica
              </h6> */}

              <p className="text-muted small mb-3">
                Acceda utilizando su ClaveÚnica.
              </p>

              <div className="text-center mb-2">
                <Button
                  onClick={handleClaveUnica}
                  disabled={loading}
                  className="btn-cu btn-m btn-color-estandar"
                  aria-label="Iniciar sesión con ClaveÚnica"

                  style={{ border: "none", fontSize: "16px" }}
                >
                  {loading ? (
                    <>
                      <Spinner as="span" animation="border" size="sm" className="me-2" />
                      Redirigiendo...
                    </>
                  ) : (
                    <>
                      {/* Ícono de Clave Única */}
                      <svg width="24"
                        className="mb-1"
                        height="24"
                        viewBox="0 0 25 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.4998 13.8956C12.9835 13.8956 13.3756 14.2878 13.3756 14.7715C13.3756 15.2552 12.9835 15.6473 12.4998 15.6473C12.0161 15.6473 11.6239 15.2552 11.6239 14.7715C11.6239 14.2878 12.0161 13.8956 12.4998 13.8956Z"
                          fill="white" />
                        <path fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M11.631 1.70078C11.631 1.21768 12.0227 0.82605 12.5058 0.82605H15.9585C16.4416 0.82605 16.8333 1.21768 16.8333 1.70078C16.8333 2.18387 16.4416 2.5755 15.9585 2.5755H13.3805V9.35701C15.9909 9.77835 17.9845 12.0421 17.9845 14.7714C17.9845 17.8006 15.5289 20.2562 12.4998 20.2562C9.47065 20.2562 7.01505 17.8006 7.01505 14.7714C7.01505 12.0379 9.01473 9.77145 11.631 9.35509V1.70078ZM8.7645 14.7714C8.7645 12.7085 10.4368 11.0361 12.4998 11.0361C14.5627 11.0361 16.2351 12.7085 16.2351 14.7714C16.2351 16.8344 14.5627 18.5067 12.4998 18.5067C10.4368 18.5067 8.7645 16.8344 8.7645 14.7714Z"
                          fill="white" />
                        <path d="M16.7507 5.65748C16.313 5.45302 15.7924 5.64209 15.5879 6.07979C15.3835 6.51748 15.5725 7.03806 16.0102 7.24252C18.8442 8.56635 20.8048 11.4409 20.8048 14.7716C20.8048 19.3583 17.0865 23.0766 12.4998 23.0766C7.91305 23.0766 4.19477 19.3583 4.19477 14.7716C4.19477 11.4517 6.14272 8.58499 8.96185 7.25542C9.39879 7.04935 9.58595 6.52809 9.37988 6.09115C9.17381 5.6542 8.65254 5.46705 8.2156 5.67312C4.80707 7.28066 2.44531 10.7494 2.44531 14.7716C2.44531 20.3245 6.94686 24.826 12.4998 24.826C18.0527 24.826 22.5543 20.3245 22.5543 14.7716C22.5543 10.7363 20.1771 7.25811 16.7507 5.65748Z"
                          fill="white" />
                      </svg>
                      <span className="cl-claveunica" aria-hidden="true"></span>
                      <span className="texto" aria-hidden="true">Iniciar sesión</span>
                    </>
                  )}
                </Button>

              </div>
            </div>

            {/* Separador */}
            {/* <div className="d-flex align-items-center gap-3">
              <hr className="flex-grow-1 my-0" />
              <span className="text-muted small">O</span>
              <hr className="flex-grow-1 my-0" />
            </div> */}

            {/* Acceso con doble factor */}
            {/* <div className="text-center">
              <p className="text-muted small mb-3">
                Accese utilizando el método de autenticación de doble factor.
              </p>
              <Button
                onClick={handleDobleFactor}
                disabled={loading}
                variant="success"
                className="btn-cu btn-m btn-primary"
                aria-label="Iniciar sesión con doble factor"
                style={{ border: "none", fontSize: "16px" }}
              >
                {loading ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      aria-hidden="true"
                    />
                    <span>Redirigiendo...</span>
                  </>
                ) : (
                  <>
                    <ShieldLock
                      size={22}
                      aria-hidden="true"
                      className="me-2"
                    />
                    <span>Iniciar sesión</span>
                  </>
                )}
              </Button>
            </div> */}

          </div>

          {/* <Button
            onClick={handlePrueba}
            disabled={loading}
            variant="primary"
            className="w-100 py-3 mb-3 fw-medium rounded-3"
            type="submit"
          >
            Acceso prueba
          </Button> */}
        </div>
      </div>

      {/* Right Section - Info Panel */}
      <div className="col-12 col-md-6 p-4 bg-color">
        <div className="h-100 d-flex flex-column">
          {/* Card de bienvenida */}
          <div className="bg-white bg-opacity-10 backdrop-blur rounded-4 p-4 mb-4 text-white position-relative">
            <h4 className="fw-bold mb-2">Sistema de Activo Fijo</h4>
            <p className="mb-3" style={{ fontSize: "14px" }}>
              Plataforma de gestión de inventario de la Red Pública Salud Sur Oriente.
            </p>
          </div>

          {/* Preguntas frecuentes */}
          <div className="flex-grow-1 overflow-auto">
            <h4 className="text-white fw-bold mb-4">Preguntas frecuentes</h4>
            <div className="space-y-2">
              {faqItems.map((item, index) => (
                <div key={index} className="bg-white bg-opacity-10 backdrop-blur rounded-3 mb-2">
                  <button
                    className="w-100 d-flex justify-content-between align-items-center p-3 bg-transparent border-0 text-white text-start"
                    onClick={() => toggleFaq(index)}
                  >
                    <span style={{ fontSize: "14px" }}>{item.question}</span>
                    <ChevronDown
                      size={16}
                      className={`transition-transform ${expandedFaq === index ? "rotate-180" : ""}`}
                    />
                  </button>
                  {expandedFaq === index && (
                    <div className="px-3 pb-3 text-white" style={{ fontSize: "13px" }}>
                      <p className="mb-0 opacity-75">{item.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Footer */}
          <footer className="text-white text-center mt-4" style={{ fontSize: "12px" }}>
            <p className="mb-0">Departamento de Informática | Unidad de Desarrollo {anio}</p>
            <p className="mb-0">Servicio de Salud Metropolitano Sur Oriente</p>
          </footer>
        </div>
      </div>
    </div>
  );

}

const mapStateToProps = (state: RootState) => ({
  isAuthenticated: state.validaApiLoginReducers.isAuthenticated,
  isDarkMode: state.darkModeReducer.isDarkMode,
  token: state.loginReducer.token,
})

export default connect(mapStateToProps, {
  parametrosUrlActions
})(ClaveUnica)
